import { Box, CircularProgress, CssBaseline } from "@mui/material";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import routes from "./routes";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import SessionBootstrap from "./Components/Common/SessionBootstrap";

function App() {
  useEffect(() => {
    if ("Notification" in window && Notification.permission !== "granted") {
      Notification.requestPermission();
    }
  }, []);

  return (
    <div className="app-main">
      <CssBaseline />

      <SessionBootstrap>
        <RouterProvider
          router={routes}
          fallbackElement={
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
              }}
            >
              <CircularProgress color="primary" />
            </Box>
          }
        />
      </SessionBootstrap>
      <ToastContainer />
    </div>
  );
}

export default App;
